import AssignmentForm from "./assignmentForm";
//--------------------------------------------------------------------------------------------
export default function PotholingPostChecklist({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Were all of the potholes documented properly - photos and data sheets on Docusite, labeled correctly?",  type: "radio", required: true},
        {title: "Were the pothole work areas cleaned properly?",  type: "radio", required: true},
        {title: "Did you collect all of the necessary photos - before and after shots?",  type: "radio", required: true},
        {title: "Were all of the potholes backfilled and, if required, pavement restored up to permit standards?",  type: "radio", required: true},
        {title: "Did you do a walk-through to ensure that all of our equipment has been collected?", type: "radio", required: true},
        {title: "Were all of the requested potholes completed? If not, why not? Explain.",  type: "radio", onNo: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <AssignmentForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}
